import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import SnAgGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_COS_BAS_REG_010 = forwardRef(({ Menuprops }: Props, ref) => {
  const [formData, setFormData] = useState<any>();
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const gridRef = useRef<any>(null);
  const { userInfo } = global();
  const [focusedRowData, setFocusedRowData] = useState<any>();

  //#region grid 길이 관련
  const cd_menu = Menuprops.cd_menu || "SN_COS_BAS_REG_010";
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setSharedForm(rtn.form.freeform1);
        setColums(rtn.grid.grid1);
        setFormData(rtn.formData);
        await onSearch();
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const mas_group = gridRef.current.getChange();

      if (mas_group.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved: any = await onSave();
          if (!isSaved) {
            return;
          }
        } else if (confirm === undefined) {
          return;
        }
      }

      const params = {
        id: "sn_cos_bas_reg_010_01",
        params: { cd_firm: userInfo.cd_firm },
      };

      setFocusedRowData(null);
      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridRef.current.selectAndFocusRow(0);
      }

      gridRef.current.resetUpdate();
    } catch (error) {}
  };

  const onInsert = () => {
    gridRef.current.addRow();
  };

  const onDelete = () => {
    gridRef.current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRef.current.api.stopEditing();
      const requiredValuesCheck = gridRef.current.requiredValuesCheck();

      if (!requiredValuesCheck) {
        return;
      }

      const grid1getChange = gridRef.current.getChange();

      if (grid1getChange.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        cos_codeh: grid1getChange,
      };
      await fnSave("SN_COS_BAS_REG_010_SAVE_01", SaveData);
      gridRef.current.resetUpdate();

      return true;
    } catch (error) {
      return false;
    }
  };

  const onBeforeAddRow = (newRow: RowData): boolean => {
    try {
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        yn_use: "Y",
        yn_system: "N",
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));


  //#region UI
  return (
    <div className="h-full  w-full flex flex-col">
      <div className="flex-1">
        <SnAgGrid
          ref={gridRef}
          
          enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource1}
          enableExternalChart={false}
          isEditable={false}
          rowSelection="single" // 단일 선택 모드
          onBeforeAddRow={onBeforeAddRow}
        />
      </div>
    </div>
  );
});

export default SN_COS_BAS_REG_010;
  